export default __webpack_public_path__ + "assets/1b8a43.svg";